import { CircularProgress, Box, Typography } from "@mui/material";
import React from "react";

import "./Progress.css";

const Progress = ({ size = 60, color = "var(--clr-theme-purple)", message = "Loading...", showMessage = true }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '70vh',
        gap: 2,
      }}
      className="progress-container"
    >
      <CircularProgress size={size} sx={{ color: color }} className="progress" />
      {showMessage && (
        <>
          <Typography
            variant='h6'
            sx={{
              color: '#333',
              fontWeight: 500,
              textAlign: 'center',
              fontFamily: 'Lato',
            }}
          >
            {message}
          </Typography>
          <Typography
            variant='body2'
            sx={{
              color: '#666',
              textAlign: 'center',
              fontFamily: 'Lato',
            }}
          >
            Please wait while we load your content
          </Typography>
        </>
      )}
    </Box>
  );
};

export default Progress;
